import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicWifiPxsplusComponent } from './public-wifi-pxsplus-container/public-wifi-pxsplus.component';
import { MyProximusAuthenticationCheckGuard } from '../guards/myproximus-authentication-check.guard';
import { PublicWifiPxsplusHowtoinstallComponent } from './public-wifi-pxsplus-howtoinstall/public-wifi-pxsplus-howtoinstall.component';
import { PublicWifiPxsplusNoSimcardComponent } from './public-wifi-pxsplus-no-simcard/public-wifi-pxsplus-no-simcard.component';

const routes: Routes = [
  {
    path: 'pxsplus/public-wifi',
    canActivate: [MyProximusAuthenticationCheckGuard],
    children: [
      {
        path: '',
        component: PublicWifiPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ public wifi',
              id: 'PXS+ public wifi',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'public wifi',
              },
            },
          },
        },
      },
      {
        path: 'howtoinstall',
        component: PublicWifiPxsplusHowtoinstallComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ public wifi how to install',
              id: 'PXS+ public wifi how to install',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'public wifi how to install',
              },
            },
          },
        },
      },
      {
        path: 'nosim',
        component: PublicWifiPxsplusNoSimcardComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ public wifi no sim',
              id: 'PXS+ public wifi no sim',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'public wifi no sim',
              },
            },
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicWifiPxplusRoutingModule {}
